
import React, { useState, useEffect } from 'react';

interface TypeAnimationProps {
  text: string;
  typingSpeed?: number; // milliseconds per character
}

const TypeAnimation: React.FC<TypeAnimationProps> = ({ 
  text, 
  typingSpeed = 50 
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (currentIndex < text.length && isTyping) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, typingSpeed);
      
      return () => clearTimeout(timeout);
    } else if (currentIndex >= text.length) {
      setIsTyping(false);
      
      // Reset after 3 seconds to repeat the animation
      const resetTimeout = setTimeout(() => {
        setDisplayedText('');
        setCurrentIndex(0);
        setIsTyping(true);
      }, 3000);
      
      return () => clearTimeout(resetTimeout);
    }
  }, [currentIndex, text, typingSpeed, isTyping]);

  return <div className="font-mono">{displayedText}<span className="animate-pulse">|</span></div>;
};

export default TypeAnimation;
